module.exports = Promise.all([__parcel__import__("bcF1k"), __parcel__import__("gQbRW")]).then(() => parcelRequire('g36Vt'));